<div class="modal-header">
    <h4 class="modal-title fw-bold" id="importSamplePlateMappingHeader" jhiTranslate="bmsjHipsterApp.sample.importPlate.mapping.title">Select Mapping</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="close()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row">
            <label class="col-6 col-form-label">
                <label class="col-form-label" jhiTranslate="bmsjHipsterApp.sample.importPlate.mapping.field.sampleuid">Please specify the header for SAMPLE_UID:</label>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownSampleUID" id="dropdownSampleUID" [(ngModel)]="sampleIdMapping" required #dropdownSampleUID="ngModel">
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-6 col-form-label">
                <label class="col-form-label" jhiTranslate="bmsjHipsterApp.sample.importPlate.mapping.field.plateid">Please specify the header for PLATE_ID:</label>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" id="dropdownPlate" name="dropdownPlate" [(ngModel)]="plateIdMapping" required #dropdownPlate="ngModel">
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3 row">
            <label class="col-6 col-form-label">
                <label class="col-form-label" jhiTranslate="bmsjHipsterApp.sample.importPlate.mapping.field.well">Please specify the header for WELL:</label>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" id="dropdownWell" name="dropdownWell" [(ngModel)]="wellMapping" required #dropdownWell="ngModel">
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.back">Back</span>
    </button>
    <button type="button" (click)="proceed()" [disabled]="!isFormValid(f)" class="btn btn-primary">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.proceed">Proceed</span>
    </button>
</div>
